module.exports = __webpack_public_path__ + "img/00027.8aeec575.webp";